/**
 * Custom scripts for Arduino
 * @todo add translation mechanism
 */

// scroll top
const backToTopToggle = document.querySelector('.ino-footer__control.ino-footer__top');

if(backToTopToggle) {
    backToTopToggle.addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
}

// enhance shopping
const enhanceShoppingContainer = document.querySelector('.ino-enhance-shopping-wrap');

function computeEnhanceShoppingTotal(moneyFormat) {
    const totalElement = document.querySelector('.ino-enhance-total span.value');
    const enhanceShoppingItems = document.querySelectorAll('.ino-enhance-input input');
    
    let total = 0;

    for(let item of enhanceShoppingItems) {
        if(item.checked) {
            total += parseInt(item.dataset.itemPrice);
        }
    }

    totalElement.innerHTML = window.Shopify.formatMoney(total, moneyFormat);
}

if(enhanceShoppingContainer) {
    if(enhanceShoppingContainer.dataset.skus) {
        let skus = enhanceShoppingContainer.dataset.skus.split(',');
        
        skus = skus.map((item, index, array) => {
            return item.trim();
        });

        const searchUrl = '/search/suggest?section_id=arduino-enhance-shopping&resources[type]=product&resources[options][fields]=variants.sku&resources[options][unavailable_products]=hide&q=' + skus.join('+OR+'); 

        // this fetch will return already rendered section with all the information about related products
        const productPromise = fetch(searchUrl);

        productPromise.then((response) => {
            if(response.ok) {
                return response.text();
            }
        }).then((text) => {
            const resultsMarkup = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.ino-enhance-shopping').innerHTML;
    
            enhanceShoppingContainer.innerHTML = resultsMarkup;

            const enhanceShoppingItems = document.querySelectorAll('.ino-enhance-input input');

            for(let item of enhanceShoppingItems) {
                item.addEventListener('change', (event) => { computeEnhanceShoppingTotal(enhanceShoppingContainer.dataset.moneyFormat); });
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    // add to cart handler
    const addToCartButton = document.querySelector('.product-form--atc-button');

    if(addToCartButton) {
        addToCartButton.addEventListener('click', (event) => {
            event.preventDefault();

            const productForm = event.target.closest('form[data-product-form]');
            const selectedItems = document.querySelectorAll('.ino-enhance-input input:checked');

            if(selectedItems.length > 0) {
                const cartData = {items: []};

                for(let item of selectedItems) {
                    cartData.items.push({
                        quantity: 1,
                        id: parseInt(item.dataset.itemId)
                    });
                }

                const addToCartPromise = fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(cartData)
                });

                addToCartPromise.then((response) => {
                    if(response.status === 200) {
                        for(let item of selectedItems) {
                            item.checked = false;
                        }

                        document.dispatchEvent(new CustomEvent('cart:update', {detail: response}));
                        productForm.dispatchEvent(new CustomEvent('submit'));
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            } else {
                document.dispatchEvent(new CustomEvent('cart:update'));
                productForm.dispatchEvent(new CustomEvent('submit'));
            }
        });
    }
}
